import React from 'react'
import BlueprintEditor from './BlueprintEditor'

function createEditor( blueprint, props ) {
  if ( blueprint == null ) {
    return null
  }
  props = props || {}
  props.blueprint = blueprint
  return <BlueprintEditor {...props} /> 
}

module.exports = {
  createEditor
}
